import { InjectionToken } from '@angular/core';
import { MojoAvatarDownloadService } from 'mojo-avatar/lib/mojo-avatar-download.service';
import { MojoAvatarConfigService } from 'mojo-avatar/lib/mojo-avatar.config.service';

export const AVATAR_DOWNLOAD_SERVICE = new InjectionToken<MojoAvatarDownloadService>('AvatarDownloadService');
export const AVATAR_CONFIG_SERVICE = new InjectionToken<MojoAvatarConfigService>('AvatarConfigService');

